/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChannelFromJSON, ApiChannelToJSON, } from './ApiChannel';
export function ApiCalculateChannelFromSourceResponseFromJSON(json) {
    return ApiCalculateChannelFromSourceResponseFromJSONTyped(json, false);
}
export function ApiCalculateChannelFromSourceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'channel': !exists(json, 'channel') ? undefined : ApiChannelFromJSON(json['channel']),
    };
}
export function ApiCalculateChannelFromSourceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'channel': ApiChannelToJSON(value.channel),
    };
}
